import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import * as XLSX from 'xlsx';


const ILLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin','Aydın','Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','Mersin','İstanbul','İzmir','Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa','Kahramanmaraş','Mardin','Muğla','Muş','Nevşehir','Niğde','Ordu','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak','Van','Yozgat','Zonguldak','Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak','Bartın','Ardahan','Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce'];
const tipLabel = { vet_hekim: 'Vet. Hekim', bireysel: 'Bireysel', bayi: 'Bayi', faturali_vet: 'Faturalı Vet', faturasiz_vet: 'Faturasız Vet', diger: 'Diğer' };
const durumRenk = { alinidi: 'badge-blue', hazirlaniyor: 'badge-yellow', kargoda: 'badge-orange', teslim: 'badge-green', iade: 'badge-red', iptal: 'badge-gray' };
const fmt = v => (v || 0).toLocaleString('tr-TR');

// Dropdown öneri bileşeni
function Oneri({ oneri, onSec, setOneri }) {
  if (!oneri.length) return null;
  return (
    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: '0 4px 16px rgba(0,0,0,0.15)', zIndex: 300, maxHeight: 220, overflowY: 'auto' }}>
      {oneri.map((item, i) => (
        <div key={i} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 14, borderBottom: '1px solid var(--border)' }}
          onMouseDown={e => { e.preventDefault(); onSec(typeof item === 'string' ? item : item.ad); setOneri([]); }}>
          {typeof item === 'string' ? `📍 ${item}` : item.ad}
        </div>
      ))}
    </div>
  );
}

export default function Arama() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const isTemsilci = profil?.rol === 'temsilci';

  const [anaTab, setAnaTab] = useState('siparis');
  const [loading, setLoading] = useState(false);
  const [firmalar, setFirmalar] = useState([]);
  const [altGruplar, setAltGruplar] = useState({});
  const [urunAdlari, setUrunAdlari] = useState({});
  const [urunAdlariGrup, setUrunAdlariGrup] = useState({}); // firma_id|alt_grup -> string[]
  const [tumIlceler, setTumIlceler] = useState([]);

  // ─── Sipariş filtre state'leri ───
  const [siparisNo, setSiparisNo] = useState('');
  const [musteriAdi, setMusteriAdi] = useState('');
  const [telefon, setTelefon] = useState('');
  const [sehir, setSehir] = useState('');
  const [firmaId, setFirmaId] = useState('');
  const [urunAdi, setUrunAdi] = useState('');
  const [siparisDurumu, setSiparisDurumu] = useState('');
  const [odemeDurumu, setOdemeDurumu] = useState('');
  const [faturaDurumu, setFaturaDurumu] = useState('');
  const [odemeTuru, setOdemeTuru] = useState('');
  const [tarihBas, setTarihBas] = useState('');
  const [tarihBit, setTarihBit] = useState('');
  const [filtreTemsilciId, setFiltreTemsilciId] = useState('');
  const [temsilciler, setTemsilciler] = useState([]);
  const [sonuclar, setSonuclar] = useState([]);

  // Öneri state'leri
  const [sehirOneri, setSehirOneri] = useState([]);
  const [musteriOneri, setMusteriOneri] = useState([]);

  // ─── Müşteri filtre state'leri ───
  const [vAd, setVAd] = useState('');
  const [vTel, setVTel] = useState('');
  const [vSehir, setVSehir] = useState('');
  const [vIlce, setVIlce] = useState('');
  const [vTip, setVTip] = useState('');
  const [vFirma, setVFirma] = useState('');
  const [vetSonuclar, setVetSonuclar] = useState([]);
  const [vSehirOneri, setVSehirOneri] = useState([]);
  const [ilceOneri, setIlceOneri] = useState([]);

  // ─── Ürün analizi ───
  const [urunAdi2, setUrunAdi2] = useState('');
  const [firmaId2, setFirmaId2] = useState('');
  const [grup2, setGrup2] = useState('');
  const [tarihBas2, setTarihBas2] = useState('');
  const [tarihBit2, setTarihBit2] = useState('');
  const [urunSonuc, setUrunSonuc] = useState(null);
  const [urunTab, setUrunTab] = useState('ozet');

  useEffect(() => { fetchMeta(); }, []);

  async function fetchMeta() {
    const [{ data: f }, { data: u }, { data: il }, { data: t }] = await Promise.all([
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
      supabase.from('urunler').select('firma_id, alt_grup, ad').eq('aktif', true),
      supabase.from('musteriler').select('ilce').eq('aktif', true),
      supabase.from('kullanicilar').select('id, ad, soyad').in('rol', ['temsilci', 'admin', 'super_admin']).eq('aktif', true),
    ]);
    setFirmalar(f || []);
    setTemsilciler(t || []);

    // alt grup ve ürün adı map'i — firma bazında ve firma+altgrup bazında
    const agMap = {}, uaMap = {}, uaGrupMap = {};
    (u || []).forEach(x => {
      if (!x.firma_id) return;
      const alt_grup_temiz = (x.alt_grup || '').trim();
      if (alt_grup_temiz) { if (!agMap[x.firma_id]) agMap[x.firma_id] = new Set(); agMap[x.firma_id].add(alt_grup_temiz); }
      if (x.ad) {
        if (!uaMap[x.firma_id]) uaMap[x.firma_id] = new Set();
        uaMap[x.firma_id].add(x.ad);
        const key = `${x.firma_id}|${alt_grup_temiz}`;
        if (!uaGrupMap[key]) uaGrupMap[key] = new Set();
        uaGrupMap[key].add(x.ad);
      }
    });
    const ag = {}, ua = {}, uaGrup = {};
    Object.keys(agMap).forEach(k => { ag[k] = [...agMap[k]].sort(); });
    Object.keys(uaMap).forEach(k => { ua[k] = [...uaMap[k]].sort(); });
    Object.keys(uaGrupMap).forEach(k => { uaGrup[k] = [...uaGrupMap[k]].sort(); });
    setAltGruplar(ag);
    setUrunAdlari(ua);
    setUrunAdlariGrup(uaGrup);

    const ilSet = new Set((il || []).map(m => m.ilce).filter(Boolean));
    setTumIlceler([...ilSet].sort());
  }

  // ─── SİPARİŞ ARAMA ───
  // useCallback + tüm bağımlılıklar — closure sorunu yok
  const siparisAra = useCallback(async () => {
    setLoading(true);
    try {
      let q = supabase.from('siparisler')
        .select('id, siparis_no, siparis_durumu, odeme_durumu, fatura_durumu, odeme_turu, toplam_tutar, toplam_komisyon, created_at, musteri_id, firma_id, siparis_kalemleri(urunler(ad))')
        .order('created_at', { ascending: false })
        .limit(500);

      if (isTemsilci) q = q.eq('temsilci_id', profil.id);
      else if (filtreTemsilciId) q = q.eq('temsilci_id', filtreTemsilciId);
      if (siparisNo) q = q.ilike('siparis_no', `%${siparisNo}%`);
      if (siparisDurumu) q = q.eq('siparis_durumu', siparisDurumu);
      if (odemeDurumu) q = q.eq('odeme_durumu', odemeDurumu);
      if (odemeTuru) q = q.eq('odeme_turu', odemeTuru);
      if (firmaId) q = q.eq('firma_id', firmaId);
      if (faturaDurumu !== '') q = q.eq('fatura_durumu', faturaDurumu === 'true');
      if (tarihBas) q = q.gte('created_at', tarihBas);
      if (tarihBit) q = q.lte('created_at', tarihBit + 'T23:59:59');

      let { data } = await q;
      data = data || [];

      // Firma adları
      const firmaMap = {};
      firmalar.forEach(f => { firmaMap[f.id] = f.ad; });

      // Müşterileri ayrı çek
      const mIds = [...new Set(data.map(s => s.musteri_id).filter(Boolean))];
      let mMap = {};
      if (mIds.length > 0) {
        const { data: ml } = await supabase.from('musteriler').select('id, ad, telefon, sehir').in('id', mIds);
        (ml || []).forEach(m => { mMap[m.id] = m; });
      }

      data = data.map(s => ({ ...s, musteriler: mMap[s.musteri_id] || null, firmalar: { ad: firmaMap[s.firma_id] || '' } }));

      // Client-side filtreler
      if (musteriAdi) data = data.filter(s => s.musteriler?.ad?.toLowerCase().includes(musteriAdi.toLowerCase()));
      if (telefon) data = data.filter(s => (s.musteriler?.telefon || '').includes(telefon));
      if (sehir) data = data.filter(s => (s.musteriler?.sehir || '').toLowerCase().startsWith(sehir.toLowerCase()));
      if (urunAdi) data = data.filter(s => s.siparis_kalemleri?.some(k => k.urunler?.ad?.toLowerCase().includes(urunAdi.toLowerCase())));

      setSonuclar(data);
    } catch (err) { console.error('Sipariş arama hatası:', err); }
    setLoading(false);
  }, [isTemsilci, profil?.id, siparisNo, musteriAdi, telefon, sehir, firmaId, urunAdi, siparisDurumu, odemeDurumu, faturaDurumu, odemeTuru, tarihBas, tarihBit, firmalar]);

  // ─── MÜŞTERİ ARAMA ───
  const veterinerAra = useCallback(async () => {
    setLoading(true);
    try {
      let q = supabase.from('musteriler').select('id, ad, telefon, sehir, ilce, musteri_tipi').eq('aktif', true).order('ad').limit(500);
      if (isTemsilci) q = q.eq('temsilci_id', profil.id);
      if (vTip) q = q.eq('musteri_tipi', vTip);
      let { data } = await q;
      data = data || [];
      if (vAd) data = data.filter(m => m.ad.toLowerCase().includes(vAd.toLowerCase()));
      if (vTel) data = data.filter(m => (m.telefon || '').includes(vTel));
      if (vSehir) data = data.filter(m => (m.sehir || '').toLowerCase().startsWith(vSehir.toLowerCase()));
      if (vIlce) data = data.filter(m => (m.ilce || '').toLowerCase().startsWith(vIlce.toLowerCase()));

      // Firma filtresi — siparişlerden kontrol et
      if (vFirma) {
        const { data: siparisData } = await supabase.from('siparisler').select('musteri_id').eq('firma_id', vFirma);
        const musteriIds = new Set((siparisData || []).map(s => s.musteri_id));
        data = data.filter(m => musteriIds.has(m.id));
      }

      setVetSonuclar(data);
    } catch (err) { console.error('Müşteri arama hatası:', err); }
    setLoading(false);
  }, [isTemsilci, profil?.id, vAd, vTel, vSehir, vIlce, vTip, vFirma]);

  // Debounce ile aramayı tetikle
  const siparisTimer = useRef(null);
  const vetTimer = useRef(null);

  useEffect(() => {
    if (anaTab !== 'siparis') return;
    clearTimeout(siparisTimer.current);
    siparisTimer.current = setTimeout(() => siparisAra(), 400);
    return () => clearTimeout(siparisTimer.current);
  }, [siparisAra, anaTab]);

  useEffect(() => {
    if (anaTab !== 'veteriner') return;
    clearTimeout(vetTimer.current);
    vetTimer.current = setTimeout(() => veterinerAra(), 400);
    return () => clearTimeout(vetTimer.current);
  }, [veterinerAra, anaTab]);

  // Sipariş sekmesinde firmaya göre filtrelenmiş ürün adları
  const filtreliUrunAdlari = firmaId ? (urunAdlari[firmaId] || []) : [];

  // ─── ÜRÜN ANALİZİ ───
  async function urunAra() {
    if (!urunAdi2 && !firmaId2 && !grup2) { alert('En az bir filtre girin'); return; }
    setLoading(true);
    try {
      // Önce filtreye uyan ürünlerin ID'lerini bul.
      // NOT: burada aktif=true FİLTRESİ KOYMUYORUZ — bir ürün fiyat/güncelleme
      // yüzünden pasife alınıp aynı isimle yeniden oluşturulmuş olabilir; geçmiş
      // satışlar eski (artık pasif) ürün ID'sine bağlı kalmaya devam eder. Sadece
      // aktif ürünleri arasak, o eski satışları tamamen kaçırırız.
      // Alt Grup karşılaştırmasını DB sorgusunda değil (aşağıda) JS
      // tarafında, trim'leyerek yapıyoruz: dropdown'daki alt grup listesi
      // trim'lenmiş değerlerden oluşuyor ama urunler.alt_grup alanında
      // görünmeyen boşluklu kayıtlar olabiliyor — .eq('alt_grup', grup2)
      // birebir string eşleşmesi arayıp bu yüzden hep 0 sonuç veriyordu.
      let urunQ = supabase.from('urunler').select('id, ad, alt_grup, firma_id, aktif, firmalar(ad)');
      if (firmaId2) urunQ = urunQ.eq('firma_id', firmaId2);
      if (urunAdi2) urunQ = urunQ.eq('ad', urunAdi2);
      const { data: urunlerHam, error: urunHata } = await urunQ;
      if (urunHata) console.error('[ÜrünAnaliz] ürün sorgu hatası:', urunHata);
      const filtreliUrunler = grup2
        ? (urunlerHam || []).filter(u => (u.alt_grup || '').trim() === grup2.trim())
        : (urunlerHam || []);
      console.log('[ÜrünAnaliz] eşleşen ürün kayıtları:', filtreliUrunler);
      if (!filtreliUrunler || filtreliUrunler.length === 0) {
        setUrunSonuc({ kalemler: [], toplamAdet: 0, toplamTutar: 0, toplamKomisyon: 0, vetListesi: [], aylik: [], sehirler: [], ilceler: [], detaySatirlari: [] });
        setLoading(false);
        return;
      }
      const urunIds = filtreliUrunler.map(u => u.id);

      // Bu ürün ID'lerine (aktif/pasif fark etmeksizin) ait TÜM sipariş
      // kalemlerini çek (sipariş tarafını önceden 5000'e kısıtlayıp
      // filtrelemek, sistemde 5000'den fazla sipariş varsa ilgili ürünü
      // kaçırıyordu — o yüzden akışı ters çevirdik)
      const { data: kalemlerHam, error: kalemHataHam } = await supabase.from('siparis_kalemleri')
        .select('miktar, toplam, komisyon_tutari, siparis_id, urun_id, urunler(ad, alt_grup, firma_id, firmalar(ad))')
        .in('urun_id', urunIds)
        .limit(10000);
      if (kalemHataHam) console.error('[ÜrünAnaliz] kalem sorgu hatası:', kalemHataHam);
      console.log('[ÜrünAnaliz] bulunan sipariş kalemi sayısı:', (kalemlerHam || []).length);

      const kalemSiparisIds = [...new Set((kalemlerHam || []).map(k => k.siparis_id).filter(Boolean))];
      if (kalemSiparisIds.length === 0) {
        setUrunSonuc({ kalemler: [], toplamAdet: 0, toplamTutar: 0, toplamKomisyon: 0, vetListesi: [], aylik: [], sehirler: [], ilceler: [], detaySatirlari: [] });
        setLoading(false);
        return;
      }

      // Şimdi sadece bu siparişleri, tarih/durum filtresiyle çek
      let sipQ = supabase.from('siparisler')
        .select('id, siparis_no, created_at, musteri_id, siparis_durumu')
        .in('id', kalemSiparisIds)
        .neq('siparis_durumu', 'iptal');
      if (tarihBas2) sipQ = sipQ.gte('created_at', tarihBas2);
      if (tarihBit2) sipQ = sipQ.lte('created_at', tarihBit2 + 'T23:59:59');
      const { data: siparisler, error: sipHata } = await sipQ;
      if (sipHata) console.error('[ÜrünAnaliz] sipariş sorgu hatası:', sipHata);
      console.log('[ÜrünAnaliz] tarih/durum filtresinden geçen sipariş sayısı:', (siparisler || []).length);
      if (!siparisler || siparisler.length === 0) {
        setUrunSonuc({ kalemler: [], toplamAdet: 0, toplamTutar: 0, toplamKomisyon: 0, vetListesi: [], aylik: [], sehirler: [], ilceler: [], detaySatirlari: [] });
        setLoading(false);
        return;
      }
      const siparisMap = {};
      siparisler.forEach(s => { siparisMap[s.id] = s; });

      // Müşteri bilgilerini çek
      const mIds = [...new Set(siparisler.map(s => s.musteri_id).filter(Boolean))];
      let mMap = {};
      if (mIds.length > 0) {
        const { data: ml } = await supabase.from('musteriler').select('id, ad, telefon, sehir, ilce').in('id', mIds);
        (ml || []).forEach(m => { mMap[m.id] = m; });
      }

      // Veriyi birleştir — sadece tarih/durum filtresinden geçen siparişlere ait kalemler
      const data = (kalemlerHam || [])
        .filter(k => siparisMap[k.siparis_id])
        .map(k => ({
          ...k,
          siparisler: {
            ...siparisMap[k.siparis_id],
            musteriler: mMap[siparisMap[k.siparis_id]?.musteri_id] || null
          }
        }));

      const toplamAdet = data.reduce((a, k) => a + (k.miktar || 0), 0);
      const toplamTutar = data.reduce((a, k) => a + (k.toplam || 0), 0);
      const toplamKomisyon = data.reduce((a, k) => a + (k.komisyon_tutari || 0), 0);

      const vetMap = {}, ayMap = {}, sehirMap = {}, ilceMap = {};
      data.forEach(k => {
        const ad = k.siparisler?.musteriler?.ad || 'Bilinmiyor';
        const sehir = k.siparisler?.musteriler?.sehir || '-';
        const ilce = k.siparisler?.musteriler?.ilce || '-';
        if (!vetMap[ad]) vetMap[ad] = { ad, sehir, ilce, telefon: k.siparisler?.musteriler?.telefon || '', adet: 0, tutar: 0 };
        vetMap[ad].adet += k.miktar || 0; vetMap[ad].tutar += k.toplam || 0;
        if (k.siparisler?.created_at) {
          const ay = k.siparisler.created_at.substring(0, 7);
          if (!ayMap[ay]) ayMap[ay] = { ay, adet: 0, tutar: 0 };
          ayMap[ay].adet += k.miktar || 0; ayMap[ay].tutar += k.toplam || 0;
        }
        if (!sehirMap[sehir]) sehirMap[sehir] = { sehir, adet: 0 };
        sehirMap[sehir].adet += k.miktar || 0;
        const ilceKey = `${sehir}|${ilce}`;
        if (!ilceMap[ilceKey]) ilceMap[ilceKey] = { sehir, ilce, adet: 0 };
        ilceMap[ilceKey].adet += k.miktar || 0;
      });

      // Detay tablosu için satır satır liste (tarihe göre yeniden eskiye)
      const detaySatirlari = data
        .map(k => ({
          tarih: k.siparisler?.created_at || null,
          musteri: k.siparisler?.musteriler?.ad || 'Bilinmiyor',
          telefon: k.siparisler?.musteriler?.telefon || '',
          sehir: k.siparisler?.musteriler?.sehir || '-',
          ilce: k.siparisler?.musteriler?.ilce || '-',
          siparisNo: k.siparisler?.siparis_no || '',
          miktar: k.miktar || 0,
          tutar: k.toplam || 0,
        }))
        .sort((a, b) => (b.tarih || '').localeCompare(a.tarih || ''));

      setUrunSonuc({
        kalemler: data,
        toplamAdet, toplamTutar, toplamKomisyon,
        vetListesi: Object.values(vetMap).sort((a, b) => b.adet - a.adet),
        aylik: Object.values(ayMap).sort((a, b) => a.ay.localeCompare(b.ay)),
        sehirler: Object.values(sehirMap).sort((a, b) => b.adet - a.adet),
        ilceler: Object.values(ilceMap).sort((a, b) => b.adet - a.adet),
        detaySatirlari,
      });
    } catch (err) { console.error('Ürün analiz hatası:', err); }
    setLoading(false);
  }

  // Excel
  function siparisExcel() { const rows = sonuclar.map(s => ({ 'Sipariş No': s.siparis_no, 'Müşteri': s.musteriler?.ad, 'Telefon': s.musteriler?.telefon, 'Şehir': s.musteriler?.sehir, 'Firma': s.firmalar?.ad, 'Tutar': s.toplam_tutar, 'Durum': s.siparis_durumu, 'Ödeme': s.odeme_durumu, 'Tarih': new Date(s.created_at).toLocaleDateString('tr-TR') })); const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Siparişler'); XLSX.writeFile(wb, `arama_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.xlsx`); }
  function vetExcel() { const rows = vetSonuclar.map(m => ({ 'Ad': m.ad, 'Telefon': m.telefon, 'Şehir': m.sehir, 'İlçe': m.ilce, 'Tip': tipLabel[m.musteri_tipi] || m.musteri_tipi })); const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Müşteriler'); XLSX.writeFile(wb, `musteriler_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.xlsx`); }
  function urunExcel() { if (!urunSonuc) return; const rows = urunSonuc.kalemler.map(k => ({ 'Ürün': k.urunler?.ad, 'Müşteri': k.siparisler?.musteriler?.ad, 'Telefon': k.siparisler?.musteriler?.telefon, 'Şehir': k.siparisler?.musteriler?.sehir, 'İlçe': k.siparisler?.musteriler?.ilce, 'Sipariş No': k.siparisler?.siparis_no, 'Miktar': k.miktar, 'Tutar': k.toplam, 'Tarih': k.siparisler?.created_at ? new Date(k.siparisler.created_at).toLocaleDateString('tr-TR') : '' })); const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Ürün Analiz'); XLSX.writeFile(wb, `urun_analiz_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.xlsx`); }

  const [mAnalizAd, setMAnalizAd] = useState('');
  const [mAnalizSonuclar, setMAnalizSonuclar] = useState([]);
  const [mAnalizSecili, setMAnalizSecili] = useState(null);
  const [mAnalizDetay, setMAnalizDetay] = useState(null);
  const [mAnalizTarihBas, setMAnalizTarihBas] = useState('');
  const [mAnalizTarihBit, setMAnalizTarihBit] = useState('');
  const [mAnalizLoading, setMAnalizLoading] = useState(false);

  async function musteriAnalizAra() {
    if (!mAnalizAd.trim()) return;
    setMAnalizLoading(true);
    const { data } = await supabase.from('musteriler').select('id, ad, telefon, sehir').eq('aktif', true).ilike('ad', `%${mAnalizAd}%`).limit(20);
    setMAnalizSonuclar(data || []);
    setMAnalizSecili(null);
    setMAnalizDetay(null);
    setMAnalizLoading(false);
  }

  async function musteriAnalizGetir(musteri) {
    setMAnalizSecili(musteri);
    setMAnalizLoading(true);
    let q = supabase.from('siparisler')
      .select('id, siparis_no, toplam_tutar, created_at, firma_id, siparis_kalemleri(miktar, toplam, urunler(ad, alt_grup))')
      .eq('musteri_id', musteri.id)
      .neq('siparis_tipi', 'numune')
      .order('created_at', { ascending: false });
    if (mAnalizTarihBas) q = q.gte('created_at', mAnalizTarihBas);
    if (mAnalizTarihBit) q = q.lte('created_at', mAnalizTarihBit + 'T23:59:59');
    const { data: siparisler } = await q;

    // Ürün bazlı toplam
    const urunMap = {};
    (siparisler || []).forEach(s => {
      (s.siparis_kalemleri || []).forEach(k => {
        const ad = k.urunler?.ad || 'Bilinmiyor';
        if (!urunMap[ad]) urunMap[ad] = { ad, altGrup: k.urunler?.alt_grup || '', miktar: 0, toplam: 0 };
        urunMap[ad].miktar += k.miktar || 0;
        urunMap[ad].toplam += k.toplam || 0;
      });
    });
    const urunler = Object.values(urunMap).sort((a, b) => b.miktar - a.miktar);

    // Aylık toplam
    const ayMap = {};
    (siparisler || []).forEach(s => {
      const tarih = new Date(new Date(s.created_at).getTime() + 3 * 60 * 60 * 1000);
      const ay = `${tarih.getFullYear()}-${String(tarih.getMonth() + 1).padStart(2, '0')}`;
      if (!ayMap[ay]) ayMap[ay] = { ay, tutar: 0, adet: 0 };
      ayMap[ay].tutar += s.toplam_tutar || 0;
      ayMap[ay].adet += 1;
    });
    const aylar = Object.values(ayMap).sort((a, b) => b.ay.localeCompare(a.ay));

    setMAnalizDetay({
      siparisler: siparisler || [],
      urunler,
      aylar,
      toplamTutar: (siparisler || []).reduce((a, s) => a + (s.toplam_tutar || 0), 0),
      toplamAdet: (siparisler || []).length,
    });
    setMAnalizLoading(false);
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>🔍 Gelişmiş Arama</h1>
      </div>

      <div className="tabs" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <button className={`tab-btn ${anaTab === 'siparis' ? 'active' : ''}`} onClick={() => setAnaTab('siparis')}>📦 Sipariş</button>
        <button className={`tab-btn ${anaTab === 'veteriner' ? 'active' : ''}`} onClick={() => setAnaTab('veteriner')}>👥 Müşteri</button>
        <button className={`tab-btn ${anaTab === 'urun' ? 'active' : ''}`} onClick={() => setAnaTab('urun')}>🔬 Ürün Analizi</button>
        <button className={`tab-btn ${anaTab === 'musteriAnaliz' ? 'active' : ''}`} onClick={() => setAnaTab('musteriAnaliz')}>📈 Müşteri Analizi</button>
      </div>

      {/* ─── SİPARİŞ ─── */}
      {anaTab === 'siparis' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Sipariş No</label>
              <input className="input" placeholder="ABC123..." value={siparisNo} onChange={e => setSiparisNo(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Müşteri Adı</label>
              <div style={{ position: 'relative' }}>
                <input className="input" placeholder="İsim yazın..." value={musteriAdi}
                  onChange={async e => {
                    const v = e.target.value; setMusteriAdi(v);
                    if (v.length >= 1) { let q = supabase.from('musteriler').select('id, ad').eq('aktif', true).ilike('ad', `${v}%`).limit(6); if (isTemsilci) q = q.eq('temsilci_id', profil.id); const { data } = await q; setMusteriOneri(data || []); }
                    else setMusteriOneri([]);
                  }}
                  onBlur={() => setTimeout(() => setMusteriOneri([]), 150)}
                  autoComplete="off" />
                <Oneri oneri={musteriOneri} onSec={v => setMusteriAdi(v)} setOneri={setMusteriOneri} />
              </div>
            </div>
            <div className="form-group">
              <label className="label">Telefon</label>
              <input className="input" placeholder="05XX..." value={telefon} onChange={e => setTelefon(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Şehir</label>
              <div style={{ position: 'relative' }}>
                <input className="input" placeholder="İstanbul..." value={sehir}
                  onChange={e => { setSehir(e.target.value); setSehirOneri(e.target.value.length >= 1 ? ILLER.filter(il => il.toLowerCase().startsWith(e.target.value.toLowerCase())) : []); }}
                  onBlur={() => setTimeout(() => setSehirOneri([]), 150)} autoComplete="off" />
                <Oneri oneri={sehirOneri} onSec={v => { setSehir(v); setSehirOneri([]); }} setOneri={setSehirOneri} />
              </div>
            </div>
            {/* Önce firma, sonra ürün adları o firmadan */}
            <div className="form-group">
              <label className="label">Firma</label>
              <select className="select" value={firmaId} onChange={e => { setFirmaId(e.target.value); setUrunAdi(''); }}>
                <option value="">Tüm Firmalar</option>
                {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
              </select>
            </div>
            {!isTemsilci && (
              <div className="form-group">
                <label className="label">Temsilci</label>
                <select className="select" value={filtreTemsilciId} onChange={e => setFiltreTemsilciId(e.target.value)}>
                  <option value="">Tüm Temsilciler</option>
                  {temsilciler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad}</option>)}
                </select>
              </div>
            )}
            <div className="form-group">
              <label className="label">Ürün Adı {!firmaId && <span style={{ fontSize: 11, color: 'var(--text2)', fontWeight: 400 }}>(önce firma seçin)</span>}</label>
              {firmaId ? (
                <select className="select" value={urunAdi} onChange={e => setUrunAdi(e.target.value)}>
                  <option value="">Tüm Ürünler</option>
                  {filtreliUrunAdlari.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
              ) : (
                <input className="input" placeholder="Firma seçilince aktif olur" disabled />
              )}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group"><label className="label">Sipariş Durumu</label>
                <select className="select" value={siparisDurumu} onChange={e => setSiparisDurumu(e.target.value)}>
                  <option value="">Tümü</option><option value="alinidi">Alındı</option><option value="hazirlaniyor">Hazırlanıyor</option><option value="kargoda">Kargoda</option><option value="teslim">Teslim</option><option value="iade">İade</option><option value="iptal">İptal</option>
                </select>
              </div>
              <div className="form-group"><label className="label">Ödeme Durumu</label>
                <select className="select" value={odemeDurumu} onChange={e => setOdemeDurumu(e.target.value)}>
                  <option value="">Tümü</option><option value="odendi">Ödendi</option><option value="odenmedi">Ödenmedi</option>
                </select>
              </div>
              <div className="form-group"><label className="label">Fatura</label>
                <select className="select" value={faturaDurumu} onChange={e => setFaturaDurumu(e.target.value)}>
                  <option value="">Tümü</option><option value="true">Kesildi</option><option value="false">Kesilmedi</option>
                </select>
              </div>
              <div className="form-group"><label className="label">Ödeme Türü</label>
                <select className="select" value={odemeTuru} onChange={e => setOdemeTuru(e.target.value)}>
                  <option value="">Tümü</option><option value="banka">Banka</option><option value="kredi_karti">Kredi Kartı</option><option value="elden">Elden</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group"><label className="label">Başlangıç</label><input type="date" className="input" value={tarihBas} onChange={e => setTarihBas(e.target.value)} /></div>
              <div className="form-group"><label className="label">Bitiş</label><input type="date" className="input" value={tarihBit} onChange={e => setTarihBit(e.target.value)} /></div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
              <button className="btn btn-primary" onClick={siparisAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Aranıyor...' : '🔍 Ara'}</button>
              <button className="btn btn-ghost" onClick={() => { setSiparisNo(''); setMusteriAdi(''); setTelefon(''); setSehir(''); setFirmaId(''); setUrunAdi(''); setSiparisDurumu(''); setOdemeDurumu(''); setFaturaDurumu(''); setOdemeTuru(''); setTarihBas(''); setTarihBit(''); setSonuclar([]); }}>Temizle</button>
              {sonuclar.length > 0 && <button className="btn btn-ghost btn-sm" onClick={siparisExcel}>📊</button>}
            </div>
          </div>

          {loading && <div style={{ textAlign: 'center', padding: 20, color: 'var(--text2)' }}>Aranıyor...</div>}
          {!loading && sonuclar.length > 0 && (
            <>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12 }}><strong>{sonuclar.length}</strong> sipariş</span>
                <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12, color: 'var(--green)' }}><strong>{fmt(sonuclar.reduce((a, s) => a + (s.toplam_tutar || 0), 0))}</strong> ₺</span>
                {!isTemsilci && <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12, color: 'var(--yellow)' }}>Kom: <strong>{fmt(sonuclar.reduce((a, s) => a + (s.toplam_komisyon || 0), 0))}</strong> ₺</span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {sonuclar.map(s => (
                  <div key={s.id} onClick={() => navigate(`/siparisler/${s.id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span className="mono" style={{ color: 'var(--accent)', fontWeight: 700 }}>{s.siparis_no}</span>
                      <span className={`badge ${durumRenk[s.siparis_durumu]}`}>{s.siparis_durumu}</span>
                    </div>
                    <div style={{ fontWeight: 500, fontSize: 14 }}>{s.musteriler?.ad}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>{s.firmalar?.ad} • {s.musteriler?.sehir}</div>
                    {s.siparis_kalemleri?.length > 0 && (
                      <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 4 }}>📦 {s.siparis_kalemleri.map(k => k.urunler?.ad).filter(Boolean).join(', ')}</div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 700 }}>{fmt(s.toplam_tutar)} ₺</span>
                      <span className={`badge ${s.odeme_durumu === 'odendi' ? 'badge-green' : 'badge-red'}`}>{s.odeme_durumu === 'odendi' ? 'Ödendi' : 'Ödenmedi'}</span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}

      {/* ─── MÜŞTERİ ─── */}
      {anaTab === 'veteriner' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Ad / Klinik</label>
              <input className="input" placeholder="Müşteri adı..." value={vAd} onChange={e => setVAd(e.target.value)} autoComplete="off" />
            </div>
            <div className="form-group">
              <label className="label">Telefon</label>
              <input className="input" placeholder="05XX..." value={vTel} onChange={e => setVTel(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Şehir</label>
              <div style={{ position: 'relative' }}>
                <input className="input" placeholder="İstanbul..." value={vSehir}
                  onChange={e => { setVSehir(e.target.value); setVSehirOneri(e.target.value.length >= 1 ? ILLER.filter(il => il.toLowerCase().startsWith(e.target.value.toLowerCase())) : []); }}
                  onBlur={() => setTimeout(() => setVSehirOneri([]), 150)} autoComplete="off" />
                <Oneri oneri={vSehirOneri} onSec={v => { setVSehir(v); setVSehirOneri([]); }} setOneri={setVSehirOneri} />
              </div>
            </div>
            <div className="form-group">
              <label className="label">İlçe</label>
              <div style={{ position: 'relative' }}>
                <input className="input" placeholder="Kadıköy..." value={vIlce}
                  onChange={e => { setVIlce(e.target.value); setIlceOneri(e.target.value.length >= 1 ? tumIlceler.filter(il => il.toLowerCase().startsWith(e.target.value.toLowerCase())) : []); }}
                  onBlur={() => setTimeout(() => setIlceOneri([]), 150)} autoComplete="off" />
                <Oneri oneri={ilceOneri} onSec={v => { setVIlce(v); setIlceOneri([]); }} setOneri={setIlceOneri} />
              </div>
            </div>
            <div className="form-group">
              <label className="label">Müşteri Tipi</label>
              <select className="select" value={vTip} onChange={e => setVTip(e.target.value)}>
                <option value="">Tümü</option>
                <option value="vet_hekim">Vet. Hekim</option>
                <option value="bireysel">Bireysel</option>
                <option value="bayi">Bayi</option>
              </select>
            </div>
            <div className="form-group">
              <label className="label">Firma</label>
              <select className="select" value={vFirma} onChange={e => setVFirma(e.target.value)}>
                <option value="">Tüm Firmalar</option>
                {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={veterinerAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Aranıyor...' : '🔍 Ara'}</button>
              <button className="btn btn-ghost" onClick={() => { setVAd(''); setVTel(''); setVSehir(''); setVIlce(''); setVTip(''); setVFirma(''); setVetSonuclar([]); }}>Temizle</button>
              {vetSonuclar.length > 0 && <button className="btn btn-ghost btn-sm" onClick={vetExcel}>📊</button>}
            </div>
          </div>

          {loading && <div style={{ textAlign: 'center', padding: 20, color: 'var(--text2)' }}>Aranıyor...</div>}
          {!loading && vetSonuclar.length === 0 && (vAd || vTel || vSehir || vIlce || vTip) && (
            <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Müşteri bulunamadı</div>
          )}
          {!loading && vetSonuclar.length > 0 && (
            <>
              <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 8 }}><strong>{vetSonuclar.length}</strong> müşteri bulundu</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {vetSonuclar.map(m => (
                  <div key={m.id} onClick={() => navigate(`/musteriler/${m.id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{m.ad}</span>
                      <span className="badge badge-gray" style={{ fontSize: 10 }}>{tipLabel[m.musteri_tipi] || m.musteri_tipi}</span>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text2)' }}>{m.telefon || '-'} • {m.sehir || '-'}{m.ilce ? ` / ${m.ilce}` : ''}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}

      {/* ─── ÜRÜN ANALİZİ ─── */}
      {anaTab === 'urun' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            {/* Önce firma, sonra alt grup ve ürün adı */}
            <div className="form-group">
              <label className="label">Firma</label>
              <select className="select" value={firmaId2} onChange={e => { setFirmaId2(e.target.value); setGrup2(''); setUrunAdi2(''); }}>
                <option value="">Tüm Firmalar</option>
                {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="label">Alt Grup {!firmaId2 && <span style={{ fontSize: 11, color: 'var(--text2)', fontWeight: 400 }}>(önce firma seçin)</span>}</label>
              <select className="select" value={grup2} onChange={e => setGrup2(e.target.value)} disabled={!firmaId2}>
                <option value="">{firmaId2 ? 'Tüm Alt Gruplar' : 'Önce firma seçin'}</option>
                {firmaId2 && (altGruplar[firmaId2] || []).map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="label">Ürün Adı {!firmaId2 && <span style={{ fontSize: 11, color: 'var(--text2)', fontWeight: 400 }}>(önce firma seçin)</span>}</label>
              <select className="select" value={urunAdi2} onChange={e => setUrunAdi2(e.target.value)} disabled={!firmaId2}>
                <option value="">{firmaId2 ? 'Tüm Ürünler' : 'Önce firma seçin'}</option>
                {firmaId2 && (() => {
                  // Alt grup seçiliyse filtreliUrunAdlari'ndan al
                  const filtreli = grup2
                    ? (urunAdlariGrup[`${firmaId2}|${grup2}`] || urunAdlari[firmaId2] || [])
                    : (urunAdlari[firmaId2] || []);
                  return filtreli.map(a => <option key={a} value={a}>{a}</option>);
                })()}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group"><label className="label">Başlangıç</label><input type="date" className="input" value={tarihBas2} onChange={e => setTarihBas2(e.target.value)} /></div>
              <div className="form-group"><label className="label">Bitiş</label><input type="date" className="input" value={tarihBit2} onChange={e => setTarihBit2(e.target.value)} /></div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={urunAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Analiz ediliyor...' : '🔬 Analiz Et'}</button>
              <button className="btn btn-ghost" onClick={() => { setFirmaId2(''); setGrup2(''); setUrunAdi2(''); setTarihBas2(''); setTarihBit2(''); setUrunSonuc(null); }}>Temizle</button>
              {urunSonuc && <button className="btn btn-ghost btn-sm" onClick={urunExcel}>📊</button>}
            </div>
          </div>

          {urunSonuc && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                <div className="stat-card"><div className="stat-label">Toplam Adet</div><div className="stat-value" style={{ color: 'var(--accent)' }}>{urunSonuc.toplamAdet}</div></div>
                <div className="stat-card"><div className="stat-label">Toplam Tutar</div><div className="stat-value" style={{ fontSize: 16, color: 'var(--green)' }}>{fmt(urunSonuc.toplamTutar)} ₺</div></div>
                <div className="stat-card" style={{ gridColumn: '1/-1' }}><div className="stat-label">Toplam Komisyon</div><div className="stat-value" style={{ fontSize: 16, color: 'var(--yellow)' }}>{fmt(urunSonuc.toplamKomisyon)} ₺</div></div>
              </div>
              <div className="tabs">
                <button className={`tab-btn ${urunTab === 'ozet' ? 'active' : ''}`} onClick={() => setUrunTab('ozet')}>📊 Grafik</button>
                <button className={`tab-btn ${urunTab === 'musteri' ? 'active' : ''}`} onClick={() => setUrunTab('musteri')}>👥 Müşteri</button>
                <button className={`tab-btn ${urunTab === 'tarih' ? 'active' : ''}`} onClick={() => setUrunTab('tarih')}>📅 Tarih</button>
                <button className={`tab-btn ${urunTab === 'detay' ? 'active' : ''}`} onClick={() => setUrunTab('detay')}>📋 Detay</button>
              </div>
              {urunTab === 'ozet' && (
                <div className="card">
                  <h3 style={{ marginBottom: 12, fontWeight: 700, fontSize: 14 }}>Aylık Satış Trendi</h3>
                  {urunSonuc.aylik.length === 0 ? <p style={{ color: 'var(--text2)' }}>Veri yok</p> : (<ResponsiveContainer width="100%" height={180}><BarChart data={urunSonuc.aylik}><XAxis dataKey="ay" tick={{ fill: 'var(--text2)', fontSize: 9 }} /><YAxis tick={{ fill: 'var(--text2)', fontSize: 10 }} /><Tooltip formatter={v => v + ' adet'} /><Bar dataKey="adet" fill="#e07b00" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>)}
                  <h3 style={{ marginTop: 16, marginBottom: 12, fontWeight: 700, fontSize: 14 }}>Şehir (İl) Dağılımı (Top 10)</h3>
                  {urunSonuc.sehirler.length === 0 ? <p style={{ color: 'var(--text2)' }}>Veri yok</p> : (<ResponsiveContainer width="100%" height={180}><BarChart data={urunSonuc.sehirler.slice(0, 10)} layout="vertical"><XAxis type="number" tick={{ fill: 'var(--text2)', fontSize: 9 }} /><YAxis dataKey="sehir" type="category" tick={{ fill: 'var(--text2)', fontSize: 9 }} width={60} /><Tooltip formatter={v => v + ' adet'} /><Bar dataKey="adet" fill="#3b82f6" radius={[0, 4, 4, 0]} /></BarChart></ResponsiveContainer>)}
                  <h3 style={{ marginTop: 16, marginBottom: 12, fontWeight: 700, fontSize: 14 }}>İlçe Dağılımı (Top 10)</h3>
                  {urunSonuc.ilceler.length === 0 ? <p style={{ color: 'var(--text2)' }}>Veri yok</p> : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {urunSonuc.ilceler.slice(0, 10).map((il, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--bg3)', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                          <span style={{ fontSize: 13 }}>{il.sehir} {il.ilce !== '-' ? `/ ${il.ilce}` : ''}</span>
                          <span style={{ fontWeight: 700, color: 'var(--accent)' }}>{il.adet} adet</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {urunTab === 'musteri' && (<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{urunSonuc.vetListesi.map((v, i) => (<div key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}><div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>{v.ad}</span><span style={{ color: 'var(--accent)', fontWeight: 700 }}>{v.adet} adet</span></div><div style={{ fontSize: 12, color: 'var(--text2)' }}>{v.sehir}{v.ilce && v.ilce !== '-' ? ` / ${v.ilce}` : ''} • {v.telefon || '-'} • {fmt(v.tutar)} ₺</div></div>))}</div>)}
              {urunTab === 'tarih' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {urunSonuc.aylik.length === 0 ? <p style={{ color: 'var(--text2)', textAlign: 'center', padding: 20 }}>Veri yok</p> : (
                    [...urunSonuc.aylik].sort((a, b) => b.ay.localeCompare(a.ay)).map((a, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                        <span style={{ fontWeight: 600 }}>{a.ay}</span>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontWeight: 700, color: 'var(--accent)' }}>{a.adet} adet</div>
                          <div style={{ fontSize: 12, color: 'var(--green)' }}>{fmt(a.tutar)} ₺</div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
              {urunTab === 'detay' && (
                <div className="card" style={{ overflowX: 'auto' }}>
                  {urunSonuc.detaySatirlari.length === 0 ? <p style={{ color: 'var(--text2)', textAlign: 'center', padding: 20 }}>Veri yok</p> : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                      <thead>
                        <tr style={{ textAlign: 'left', borderBottom: '2px solid var(--border)' }}>
                          <th style={{ padding: '6px 8px' }}>Tarih</th>
                          <th style={{ padding: '6px 8px' }}>Müşteri</th>
                          <th style={{ padding: '6px 8px' }}>Şehir</th>
                          <th style={{ padding: '6px 8px' }}>İlçe</th>
                          <th style={{ padding: '6px 8px', textAlign: 'right' }}>Miktar</th>
                          <th style={{ padding: '6px 8px', textAlign: 'right' }}>Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {urunSonuc.detaySatirlari.map((s, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                            <td style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>{s.tarih ? new Date(s.tarih).toLocaleDateString('tr-TR') : '-'}</td>
                            <td style={{ padding: '6px 8px' }}>{s.musteri}</td>
                            <td style={{ padding: '6px 8px' }}>{s.sehir}</td>
                            <td style={{ padding: '6px 8px' }}>{s.ilce}</td>
                            <td style={{ padding: '6px 8px', textAlign: 'right' }}>{s.miktar}</td>
                            <td style={{ padding: '6px 8px', textAlign: 'right' }}>{fmt(s.tutar)} ₺</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* ─── MÜŞTERİ ANALİZİ ─── */}
      {anaTab === 'musteriAnaliz' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Müşteri Adı</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="input" placeholder="Müşteri adı yazın..." value={mAnalizAd}
                  onChange={e => setMAnalizAd(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && musteriAnalizAra()} />
                <button className="btn btn-primary" onClick={musteriAnalizAra} disabled={mAnalizLoading}>🔍 Ara</button>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group">
                <label className="label">Başlangıç Tarihi</label>
                <input type="date" className="input" value={mAnalizTarihBas} onChange={e => setMAnalizTarihBas(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="label">Bitiş Tarihi</label>
                <input type="date" className="input" value={mAnalizTarihBit} onChange={e => setMAnalizTarihBit(e.target.value)} />
              </div>
            </div>
          </div>

          {mAnalizSonuclar.length > 0 && !mAnalizSecili && (
            <div className="card" style={{ marginBottom: 12 }}>
              <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 10 }}>Müşteri seçin:</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {mAnalizSonuclar.map(m => (
                  <div key={m.id} onClick={() => musteriAnalizGetir(m)}
                    style={{ padding: '10px 14px', background: 'var(--bg3)', borderRadius: 'var(--r)', cursor: 'pointer', border: '1px solid var(--border)' }}>
                    <div style={{ fontWeight: 600 }}>{m.ad}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)' }}>{m.telefon} • {m.sehir}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {mAnalizLoading && <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Yükleniyor...</div>}

          {mAnalizDetay && mAnalizSecili && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <h3 style={{ fontWeight: 700, fontSize: 16 }}>{mAnalizSecili.ad}</h3>
                  <p style={{ fontSize: 12, color: 'var(--text2)' }}>{mAnalizSecili.sehir} • {mAnalizSecili.telefon}</p>
                </div>
                <button className="btn btn-ghost btn-sm" onClick={() => { setMAnalizSecili(null); setMAnalizDetay(null); setMAnalizSonuclar([]); setMAnalizAd(''); }}>← Geri</button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
                <div className="stat-card"><div className="stat-label">Toplam Sipariş</div><div className="stat-value">{mAnalizDetay.toplamAdet}</div></div>
                <div className="stat-card"><div className="stat-label">Toplam Tutar</div><div className="stat-value" style={{ fontSize: 18, color: 'var(--accent)' }}>{fmt(mAnalizDetay.toplamTutar)} ₺</div></div>
              </div>
              <div className="card" style={{ marginBottom: 12 }}>
                <h4 style={{ fontWeight: 700, marginBottom: 12, fontSize: 14 }}>📦 Ürün Bazlı Alımlar</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {mAnalizDetay.urunler.map((u, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--bg3)', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                      <div>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>{u.ad}</div>
                        {u.altGrup && <div style={{ fontSize: 11, color: 'var(--text2)' }}>{u.altGrup}</div>}
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 700, color: 'var(--accent)', fontSize: 15 }}>{u.miktar} adet</div>
                        <div style={{ fontSize: 12, color: 'var(--green)' }}>{fmt(u.toplam)} ₺</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="card">
                <h4 style={{ fontWeight: 700, marginBottom: 12, fontSize: 14 }}>📅 Aylık Alım Geçmişi</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {mAnalizDetay.aylar.map((a, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--bg3)', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                      <span style={{ fontWeight: 500 }}>{a.ay}</span>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 700, color: 'var(--accent)' }}>{a.adet} sipariş</div>
                        <div style={{ fontSize: 12, color: 'var(--green)' }}>{fmt(a.tutar)} ₺</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </>
      )}

    </div>
  );
}
